module.exports = __webpack_public_path__ + "assets/img/seach.1d652695.png";